module.exports = __webpack_public_path__ + "img/clock_in.de2abc7f.png";